import { schema } from 'normalizr'

export type InterestForm = {
  links: Array<{
    link: string
  }>
  distributor: string
  other_distributor: string
  publishing_owner: string
  first_name: string
  last_name: string
  label_artist_name: string
  email: string
  skipped_presentation: boolean
  confirmed: boolean
}

export const interestFormSchema = new schema.Entity('interestForm')

export type PageVariants = {
  initial: {
    opacity: number
  }
  in: {
    opacity: number
  }
  out: {
    opacity: number
  }
}

export const pageVariantsSchema = new schema.Entity('pageVariants')

export type Distributor = {
  distributor_name: string
  distributor_note: string
}

const distributorSchema = new schema.Entity('distributors')
export const distributorListSchema = [distributorSchema]
